import { MEDIA_API_ENDPOINT, MAGAZINE_FEED_URL } from '../app/config';
import { call } from '../utils/api';

const createQueryParams = params =>
  Object.keys(params)
    .map(k => `${k}=${params[k]}`)
    .join('&');

const addUserIdToParams = params => ({ ...params, userId: params.publisherId });

class MediaService {
  fetchDistribution(params) {
    const url =
      'content/distribution?' + createQueryParams(addUserIdToParams(params));
    return call(url, 'GET', null, false, MEDIA_API_ENDPOINT);
  }

  fetchTags(params) {
    const url =
      'content/tag/distribution?' +
      createQueryParams(addUserIdToParams(params));
    return call(url, 'GET', null, false, MEDIA_API_ENDPOINT);
  }

  fetchCategories(params) {
    const url = 'category?' + createQueryParams(addUserIdToParams(params));
    return call(url, 'GET', null, false, MEDIA_API_ENDPOINT);
  }

  generateUrl(params) {
    return encodeURI(MAGAZINE_FEED_URL + '?' + createQueryParams(params));
  }
}

export const mediaService = new MediaService();



// WEBPACK FOOTER //
// ./src/services/mediaService.js